module.exports = new __parcel__URL__("grand-theft-auto-iii.4014f79e.jpg").toString();